<template>
  <div style="width: 100%">
    <el-row type="flex" justify="space-between" style="padding-bottom: 20px;">
      <el-col v-if="!breadcrumbs">
        <slot name="title">
          <h1 class="title">
            {{ title }}
            <hr v-if="!divided" />
          </h1>
        </slot>
      </el-col>
      <el-col v-else>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            :to="{ path: r.path }"
            v-for="(r, index) in breadcrumbs.routers"
            :key="index"
            >{{ r.name }}</el-breadcrumb-item
          >
          <el-breadcrumb-item>
            <slot name="dropdown">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  {{ breadcrumbs.currentPath.name }}
                  <i class="fas fa-caret-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    icon="el-icon-arrow-right"
                    v-for="(l, index) in breadcrumbs.sameLayerPath"
                    :key="index"
                    @click.native="$router.push(l.path)"
                    >{{ l.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </slot>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col>
        <el-row type="flex" justify="end">
          <slot name="btn"></slot>
        </el-row>
      </el-col>
    </el-row>
    <slot></slot>
    <el-divider :content-position="contentPosition" v-if="divided">
      <slot name="divider"></slot>
    </el-divider>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    divided: Boolean,
    breadcrumbs: Object,
    contentPosition: { type: String, default: "center" },
  },
};
</script>

<style>
</style>
